/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{empty as t}from"../../../geometry/support/aaBoundingRect.js";class e{constructor(e="scene"){this.context=e,this.extent=t(),this.spatialReference=null}}export{e as ElevationUpdateEvent};
